import { impersonateAuth } from 'auth/impersonate';
import { oktaAuth } from 'auth/okta';

import { convertToURl } from './convertToURl';

const api = (template: string) => {
  return async (params?: object) => {
    const accessToken = await oktaAuth.getOrRenewAccessToken();
    const impersonateToken = await impersonateAuth.getImpersonateToken();
    const { method, url, urlPath } = convertToURl(template, params);
    let fetchResponse: any, response: any;
    try {
      fetchResponse = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
          ...(impersonateToken
            ? {
                'X-Impersonate-As': impersonateToken,
              }
            : null),
        },
        ...(['POST', 'PUT'].includes(method)
          ? { body: JSON.stringify(params) }
          : {}),
      });
      const contentType = fetchResponse.headers.get('Content-Type') || '';
      const isJSON = contentType.includes('application/json');
      const isText = contentType.includes('application/text');
      const isPDF = contentType.includes('application/pdf');
      const isOctetStream = contentType.includes('application/octet-stream');

      if (isJSON) {
        response = await fetchResponse.json();
        if (fetchResponse.status > 200) {
          const message = response?.message || response?.errors?.[0]?.message;
          throw new Error(message);
        }
      } else if (isText) {
        response = await fetchResponse.text();
        if (fetchResponse.status > 200) {
          throw new Error(response);
        }
      } else if (isPDF || isOctetStream) {
        const responseData = await fetchResponse.blob();

        response = new Blob([responseData], {
          type: `${fetchResponse.headers.get('Content-Type')};charset=utf-8`,
        });
        if (fetchResponse.status > 200) {
          throw new Error(
            `Blob parse Error (status ${fetchResponse.status} form server)`
          );
        }
      }
      return response;
    } catch (e: any) {
      if (typeof e === 'string') {
        throw new Error(`${e}: ${urlPath}`);
      } else {
        const prefix = e?.message || 'Failed to fetch';
        throw new Error(`${prefix}: ${urlPath}`);
      }
    }
  };
};

export default api;
